import { Component, Input, OnInit, OnDestroy, HostBinding, Output, EventEmitter } from '@angular/core';
import { ConsumerService } from '../../../../services/consumer.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'issue-history-grid-item',
    templateUrl: './issues-history-grid-item.component.html',
    host: { 'class': 'dash-grid--item third module drop-shadow bottom' }
})
export class IssueHistoryGridItemComponent implements OnInit, OnDestroy {

    @HostBinding('class.expanded') isExpanded: boolean;
    clientId: number;

    constructor(private consumerService: ConsumerService,
        private route: ActivatedRoute,
        private router: Router) {

    }

    ngOnInit() {
        this.isExpanded = false;
        this.clientId = this.route.parent.parent.snapshot.params['clientId'];
    }

    ngOnDestroy() {
    }

}
